import { useState } from 'react';

import type { Props as CreatFiatWalletProps } from '#src/components/fiatWallet/CreateFiatWallet/index.tsx';
import { CreateFiatWallet } from '#src/components/fiatWallet/CreateFiatWallet/index.tsx';
import type { Props as InterstitialContextModalProps } from '#src/components/fiatWallet/InterstitialContextModal/index.tsx';
import { InterstitialContextModal } from '#src/components/fiatWallet/InterstitialContextModal/index.tsx';

type Props = Omit<InterstitialContextModalProps, 'onAccept'> &
  CreatFiatWalletProps;

export const CreateFiatWalletWithInterstitialModal = ({
  onDecline,
  mode,
  onClose,
  ...createFiatWalletProps
}: Props) => {
  const [showCreateFiatWallet, setShowCreateFiatWallet] = useState(false);

  if (showCreateFiatWallet) {
    return (
      <CreateFiatWallet
        {...createFiatWalletProps}
        onClose={() => {
          setShowCreateFiatWallet(false);
          onClose();
        }}
      />
    );
  }

  return (
    <InterstitialContextModal
      onAccept={() => setShowCreateFiatWallet(true)}
      {...{ onDecline, mode }}
    />
  );
};
